import React from 'react';
import BasicInput from "./BasicInput";

const PostcodeInput = (props) => {
    const {
        onChange = () => {},
    } = props;

    const handleChange = (value) => {
        onChange(value.toUpperCase());
    }

    return (
        <BasicInput
            {...props}
            type={"text"}
            onChange={(value) => handleChange(value)}
        />
    )
}

export default PostcodeInput;
